import { TabLeftContent } from "./LeftContent";
import { RightContent } from "./RightContent";

export const TabContent = () => {
  return (
    <div className="d-flex align-items-stretch">
      <TabLeftContent />
      <RightContent />
    </div>
  );
};
